import React, { Component } from 'react';
import { sendJson } from '../../backend/Backend';
import '../../css/style.css';
import '../Home.css';
import '../App.css';
import {Card,Alert} from 'react-bootstrap';
import { translate } from "react-i18next";
import {GREY_LIGHT} from '../../backend/Colors';
import { getURL } from '../../backend/Backend';


class PasswordReset extends Component {

  constructor(props) {
    super(props);

    this.state = {
        uuid:this.props.uuid,
        userId:this.props.userId,
        email:'',
        password:'',
        rePassword:'',
        submitted: false,
        loading: false,
        error: '',
        message:''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    const response = await fetch(getURL(`users/${this.props.userId}`));
    const json = await response.json();
    //let newEvent = json;
    if (json.id) {
        let oldState = this.state;

        this.setState({
            ...oldState,
            email: json.email
        });
    }
}

    handleChange(e) {
        const { name, value } = e.target;
        let oldState = this.state;
        this.setState({
          ...oldState, 
          [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        let oldState = this.state;
        this.setState({...oldState, 
          submitted: true });
        const { userId, uuid, password, rePassword} = this.state;

        // stop here if form is invalid
        if (!userId || !uuid || !password || !rePassword || password.length < 6 || password !== rePassword ) {
            return;
        }

     
        
        oldState = this.state;
        this.setState({...oldState, 
          loading: true });
        this.onPasswordChange(userId, uuid, password );
    }

   
    onPasswordChange(userId, uuid, password) {
      let user = { 'userId':userId, 'uuid':uuid, 'pwd':password};
        sendJson('post', 'users/pwdReset', user).then(
            received => {
              let oldState = this.state;
              if(received.ok){
                  console.log("user saved  :-)");
                  this.setState({...oldState, 
                    loading: false,
                    message:'pwdReset'
                  });
              } else {
                console.log("Fehler  :-(");
                this.setState({...oldState, 
                  loading: false,
                  message:'pwdResetError'
                });
              }
            });
    }

    render() {
        const { t } = this.props;
        const {password, rePassword, submitted, loading, error, email } = this.state;
        return (
            <Card  style={{"background":GREY_LIGHT}}>
            <Card.Header className="text-primary"><h4>{t("passwordReset")}</h4></Card.Header>
            <Card.Body>
                    <Card.Text>
                    { this.state.message ? 
                       <Alert key={'success'} variant={'success'}>
                       {t(this.state.message)}
                     </Alert>
                    :
                    <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' }>
                        <input type="text" className="form-control" name="email" value={email} disabled="true"  maxLength={250} />
                    </div>
                    
                    <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                        <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} placeholder={t("password")}
                         maxLength={250} />
                        {submitted && (!password || password.length < 6) &&
                            <div className="text-danger">{t("pwdMin")}</div>
                        }
                    </div>
                  
                    <div className={'form-group' + (submitted && !rePassword ? ' has-error' : '')}>
                        <input type="password" className="form-control" name="rePassword" value={rePassword} onChange={this.handleChange} placeholder={t("newRePassword")} maxLength={250} />
                        {submitted && (!rePassword || password !== rePassword) &&
                            <div className="text-danger">
                            {t("pwdNotCorrect")}
                            </div>
                        }
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary float-right" disabled={loading}>{t("send")}</button>
                        {loading &&
                            <img alt="loading..." src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                    </div>
                    {error &&
                        <div className={'alert alert-danger'}>{error}</div>
                    }
                

                </form>
                    }
                    </Card.Text>
                </Card.Body>
                </Card>);
    }

}

export default translate("translations")(PasswordReset);
